import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  TAB4_HEADING1,
  TAB4_HEADING2,
  TAB4_HEADING3,
  TAB4_HEADING4,
  TAB4_LI1,
  TAB4_LI2,
  TAB4_LI3,
  TAB4_LI4,
  TAB4_LI5,
} from "../../translations/AboutUs/BusServicesAiravatSuperia";

function BusServicesAiravatSuperia() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB4_HEADING1)}
      </div>
      <div style={{ fontSize: "16px", fontWeight: "400" }}>
        {t(TAB4_HEADING2)}
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <div>
          <img
            src={getImgPath("/img/aboutus/bus_service/Airavat Superia.png")}
          />
        </div>
      </div>
      <div style={{ fontSize: "16px", fontWeight: "400" }}>
        {t(TAB4_HEADING3)}
      </div>
      <div style={{ fontSize: "16px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB4_HEADING4)}
      </div>
      <div>
        <ul style={{ margin: "0", padding: "0", marginLeft: "48px" }}>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB4_LI1)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB4_LI2)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB4_LI3)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB4_LI4)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB4_LI5)}</li>
        </ul>
      </div>
    </div>
  );
}

export default BusServicesAiravatSuperia;
